import styled from 'styled-components';

export const DashboardWrapper = styled.div`
  padding: 30px 0;
  min-height: 100vh;
`;

export const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 10px 0;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #7f8c8d;
  margin: 0;

  strong {
    color: #3498db;
    font-weight: 600;
  }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid ${(props) => props.color || '#3498db'};
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
`;

export const TableContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const TableHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #ecf0f1;
  background: #f8f9fa;
`;

export const TableTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  background: #f8f9fa;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #ecf0f1;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8f9fa;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 16px 24px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #7f8c8d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TableCell = styled.td`
  padding: 16px 24px;
  font-size: 14px;
  color: #2c3e50;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  background: ${(props) => {
    switch (props.status) {
      case 'pending':
        return '#fff3cd';
      case 'verified':
        return '#d4edda';
      case 'rejected':
        return '#f8d7da';
      default:
        return '#e9ecef';
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case 'pending':
        return '#856404';
      case 'verified':
        return '#155724';
      case 'rejected':
        return '#721c24';
      default:
        return '#495057';
    }
  }};
`;

export const RiskBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  background: ${(props) => props.color || '#95a5a6'}22;
  color: ${(props) => props.color || '#95a5a6'};
  border: 1px solid ${(props) => props.color || '#95a5a6'};
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: white;
  background: ${(props) => props.color || '#3498db'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  padding: 80px 20px;
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  font-size: 64px;
  color: #27ae60;
  margin-bottom: 20px;
`;

export const EmptyStateText = styled.p`
  font-size: 16px;
  color: #7f8c8d;
`;

export const LoadingContainer = styled.div`
  padding: 80px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #ecf0f1;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
`;

export const ModalBody = styled.div`
  padding: 24px;
`;

export const ModalFooter = styled.div`
  padding: 20px 24px;
  border-top: 1px solid #ecf0f1;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const FormGroup = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #dce1e6;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3498db;
  }

  &:disabled {
    background: #f8f9fa;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  border: 1px solid #dce1e6;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #7f8c8d;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #95a5a6;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SubmitButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: #27ae60;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #229954;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ecf0f1;

  &:last-child {
    border-bottom: none;
  }
`;

export const InfoLabel = styled.span`
  font-size: 14px;
  color: #7f8c8d;
  font-weight: 500;
`;

export const InfoValue = styled.span`
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
`;

export const RiskFactorList = styled.ul`
  margin: 12px 0 0 0;
  padding: 0 0 0 20px;
  list-style-type: disc;
`;

export const RiskFactorItem = styled.li`
  font-size: 14px;
  color: #2c3e50;
  margin-bottom: 8px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RiskScore = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #e74c3c;
`;

export const PriceComparison = styled.div`
  background: #f8f9fa;
  border-radius: 6px;
  padding: 16px;
  margin-top: 12px;
`;

export const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #dce1e6;
  }
`;

export const PriceLabel = styled.span`
  font-size: 14px;
  color: #7f8c8d;
  font-weight: 500;
`;

export const PriceValue = styled.span`
  font-size: 16px;
  color: #2c3e50;
  font-weight: 700;
`;

export const Divider = styled.div`
  height: 1px;
  background: #ecf0f1;
  margin: 24px 0;
`;
